import styles from './frontpage.module.css';
import FAQ from './faq/faq';
import FullHero from './hero/fullHero';
import Background from '../../media/background1.jpg';
import lesarabraev from '../../media/lesarabraev.pdf';
import NumberOfResponses from './numberOfResponses/numberOfResponses';
import Vision from './vision/vision';

const Frontpage = () => {
    return (
        <div className={styles.frontpageContainer}>
            <FullHero 
                imageUrl={Background} 
                altText="bakgrundsmynd"
                headline="Ynskir tú eisini góðar umstøður til at súkkla og ganga í Havnini?"
                //paragraph={<>Ger sum <NumberOfResponses /> onnur og vís okkum undirtøku at arbeiða fyri hesum.</>}
                cta="Vís undirtøku"
                ctaLink="http://sukkla.fo/limir"
            />
            <div className={styles.NewsContainer}>
                <h3>Aktuelt um mvg-frítøku av elsúkklum</h3>
                <p>Les okkara lesarabræv í samband við mvg-frítøku av elsúkklum<a href="https://lesarin.fo/#/articles/flutningur-er-meira-enn-bilar-avtakid-eisini-mvg-fyri-elsukklur" target="_blank" rel="noopener noreferrer"> her. </a></p>
                <p>Og les uppfylgjandi grein við landsstýrismannin í fíggjarmálum, Aksel V. Johannesen, og handilseigara á Rent a Bike<a href="https://in.fo/news-detail/vert-at-umhugsa-at-taka-mvg-av-elsuklum" target="_blank" rel="noopener noreferrer"> her. </a></p>
                <p>Hoyringarskrivið í samband við mvg-frítøku av brennievni, kann lesast<a href="https://in.fo/news-detail/gerid-flytfoeri-biligari-vid-at-taka-mvg-av-elsukklum" target="_blank" rel="noopener noreferrer"> her. </a></p>
                <p>Grein frá 2022, har tá verandi landsstýrismaðurin í fíggjarmálum, Uni Rasmussen, umrøður m.a. mvg-frítøku av elsúkklum, kann lesast<a href='https://kvf.fo/greinar/2022/04/27/umhugsar-sleppa-solorku-undan-meirvirdisgjaldi' target="_blank" rel="noopener noreferrer"> her. </a></p>
            </div>
            <h2>Vælkomin til felagið fyri súkklarar og ábæra ferðslu</h2>
            <p>Felagið arbeiðir fyri at skapa betri umstøður fyri súkklarar og gangandi í Havnini. Tað gera vit við at arbeiða saman við kommununi, stovnum, feløgum og skipa fyri tiltøkum fyri havnaborgarar.
            </p>
            <Vision />
            <div className={styles.iframeContainer}>
                <iframe title="vimeo-player" src="https://player.vimeo.com/video/1189397734?h=223986ce44"></iframe>
            </div>
            <i>Filmur frá Tórshavnar Kommunu um súkkling í Havnini.</i>
            <FAQ />
        </div>
    );
}

export default Frontpage;
